(() => {
  'use strict';

  const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

  const startCountdown = (section) => {
    if (section.dataset.countdownReady === 'true') return;
    section.dataset.countdownReady = 'true';

    const endTime = new Date(section.dataset.end).getTime();
    if (!Number.isFinite(endTime)) {
      section.hidden = true;
      return;
    }

    const fields = {
      days: section.querySelector('[data-countdown-days]'),
      hours: section.querySelector('[data-countdown-hours]'),
      minutes: section.querySelector('[data-countdown-minutes]'),
      seconds: section.querySelector('[data-countdown-seconds]'),
    };
    const label = section.querySelector('.amelie-offer-countdown__clock-label');
    let timer = 0;

    const render = () => {
      const remaining = Math.max(0, endTime - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (fields.days) fields.days.textContent = pad(days);
      if (fields.hours) fields.hours.textContent = pad(hours);
      if (fields.minutes) fields.minutes.textContent = pad(minutes);
      if (fields.seconds) fields.seconds.textContent = pad(seconds);

      if (remaining > 0) return;
      window.clearInterval(timer);
      section.dataset.expired = 'true';
      if (label) {
        label.textContent = section.dataset.expiredMessage || 'Esta promoción ha finalizado';
      }
    };

    render();
    if (endTime > Date.now()) timer = window.setInterval(render, 1000);
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-amelie-countdown]').forEach(startCountdown);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
